<script setup>
import ImageUpload from "vue-image-crop-upload/upload-2.vue";
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";
import {inject, onMounted, ref, watch} from "vue";
import categoriesService from "@/services/categories.service";

const form = inject("form");

const showLogoUpload = ref(false);
const categories = ref([]);
const categoriesList = ref([]);

onMounted(() => {
    getCategories();
});

watch(categories, value => {
    form.categories = value.map(item =>item.id);
})

async function getCategories() {
    const {data} = await categoriesService.getList();
    categoriesList.value = data;
    categories.value = categoriesList.value.filter(item1 => form.categories.some(item2 => parseInt(item1.id) === item2))
}

function logoCropped(imageDataUrl) {
    form.logo = imageDataUrl;
    showLogoUpload.value = false;
    form.logoUpdated = true;
}

</script>

<template>
    <div>
        <div class="d-flex align-items-center mb-1">
            <div class="image-block image-block--rounded--lg mb-4">
                <img v-if="form.logo" :src="form.logo" alt="img">
            </div>

            <div>
                <a @click="showLogoUpload = true" class="btn btn-primary">Upload Logo</a>
                <p class="modal-text m-0">Image size: 200 X 200 pixels, max file size 5 mb</p>
            </div>
        </div>

        <ImageUpload
            v-model="showLogoUpload"
            :width="200"
            :height="200"
            :noSquare="true"
            langType="en"
            @crop-success="logoCropped"
        />

        <StartupEditField
            field-name="name"
            label="Company Name"
            :required="true"
        />

        <StartupEditField
            field-name="website"
            label="Company URL"
            :required="true"
        />

        <div class="form__item input-checkbox">
            <input type="checkbox" id="hidden" v-model="form.hidden">
            <label for="hidden">Hidden</label>
        </div>

        <div class="form__item input-checkbox">
            <input type="checkbox" id="is_public" v-model="form.is_public">
            <label for="is_public">Public</label>
        </div>

        <div class="form__item input-checkbox">
            <input type="checkbox" id="sp_inactive" v-model="form.sp_inactive">
            <label for="sp_inactive">SP Inactive</label>
        </div>

        <StartupEditField
            field-name="shortDescription"
            label="Short Description"
            type="textarea"
        />

        <StartupEditField
            field-name="description"
            label="Description"
            type="textarea"
        />

        <StartupEditField
            field-name="founded"
            label="Year Founded"
            type="number"
        />

        <StartupEditField
            field-name="categories"
            v-model="categories"
            label="Categories"
            multiple
            :options="categoriesList"
        />

        <StartupEditField
            field-name="customCategories"
            label="Custom Categories"
            type="textarea"
        />

        <StartupEditField
            field-name="websiteKeywords"
            label="Keywords"
            type="textarea"
        />
    </div>
</template>

<style scoped>

</style>
